export default __webpack_public_path__ + "static/media/apple.348e84b8.svg";